<template>
  <div class="fb-step fb-slider" ref="fbSlider"
    @mousedown="startDrag"
    @touchstart="startDrag"

    @mousemove="onDrag"
    @touchmove="onDrag"

    @mouseup="stopDrag"
    @touchend="stopDrag"
    @mouseleave="stopDrag">
    <!--<div class="fb-step-title"><div class="label">Step</div><div class="index">{{ activeIndex + 1 }}</div></div> -->
    <div class="title"> {{ stepTitle }} </div>
    <md-steppers md-alternative :md-active-step.sync="active" >
      <component
        :inStepNavigation="false"
        :key="el.uuid"
        v-for="(el, index) in element.list"
        :uuid="el.uuid"
        :nid="nid"
        :sid="sid"
        :main_sid="main_sid"
        :is="el.type"
        :element="el"
        :mode="1"
        :steps="element.list.length"
        :stepIndex="index"
        :active="active"
        :validate-last-step="validate"
        :validate="validate"
        :is-draft="isDraft"
        @next-step="nextStep"
        @prev-step="prevStep"
        @set-value="$emit('set-value', $event)"
        @validation="updateValidation(index, $event)"
        @validate-form="$emit('validate-form')"
        @disable-form-validation="$emit('disable-form-validation')"
        @step-done="stepDone(index, $event)"
      ></component>
    </md-steppers>
    <div class="fb-actions" v-if="element.list.length > 1">
      <md-button aria-label="Go to the previous slide" :disabled="activeIndex == 0" class="md-icon-button" @click="prevStep(activeIndex)">
        <md-icon class="step-icon left-arrow"></md-icon>
      </md-button>
      <md-button
        :aria-label="buttonAreaLabel(index)"
        class="md-icon-button"
        @click="goToStep(index)"
        :key="index"
        v-for="(el, index) in element.list"
      >
        <md-icon class="step-icon" :class="{'active':activeIndex == index}"></md-icon>
      </md-button>
      <md-button aria-label="Go to the next slide" class="md-icon-button" :disabled="activeIndex == element.list.length - 1" @click="nextStep(activeIndex)">
        <md-icon class="step-icon right-arrow"></md-icon>
      </md-button>
    </div>
  </div>
</template>

<script>
import FbElementMixin from "./FbElementMixin";
import FbStep from "./FbStep.vue";

export default {
  name: "FbStepper",
  props: ["element", "validate"],
  mixins: [FbElementMixin],
  components: {
    FbStep
  },
  computed: {
    stepTitle() {
      return this.element.list[this.activeIndex].data.label;
    },
    valid: {
      cache: false,
      get() {
        if (this.isDraft) {
          return true;
        }
        let errors = this.validation.filter(el => {
          return el !== true;

        });
        return errors.length == 0;
      }
    }
  },
  created() {
    if (this.element.list[0] && this.element.list[0].uuid) {
      this.active = this.element.list[0].uuid;
    }
    this.$emit("validation", this.valid);
  },
  data() {
    return {
      dragging: false,
      c: { x: 0, y: 0 },
      start: { x: 0, y: 0 },
      active: "",
      activeIndex: 0,
      validation: []
    };
  },
  methods: {
    buttonAreaLabel(index) {
      return 'Slide' + index;
    },
    startDrag: function (e) {
      e = e.changedTouches ? e.changedTouches[0] : e;
      this.dragging = true;
      this.start.x = e.pageX;
      this.start.y = e.pageY;
    },
    onDrag: function (e) {

      e = e.changedTouches ? e.changedTouches[0] : e;
      if (this.dragging) {

        this.c.x = e.pageX - this.start.x;
        this.c.y = e.pageY - this.start.y;
        if (Math.abs(this.c.x) < 20) {
          return false;
        }
        else if (Math.abs(this.c.y) > 20){
          this.stopDrag();
          return false;
        }
        event.preventDefault();
        let el = this.$el.querySelector('.md-steppers-container');
        el.style.transition = "0s";
        let elWidth = el.offsetWidth;
        let pr = this.c.x * 100 / elWidth;
        if (Math.abs(pr) > 10) {
          el.style.transform = "translate3d(" + (-this.activeIndex * 100) + "%, 0 , 0)";
          el.style.transition = null;
          if (pr < 0) {
            this.nextStep(this.activeIndex);
          }
          else {
            this.prevStep(this.activeIndex);
          }
          this.stopDrag();
        }
        let move = -this.activeIndex * 100 + pr;
        el.style.transform = "translate3d(" + move + "%, 0 , 0)";
      }
    },
    stopDrag: function (e) {
      let el = this.$el.querySelector('.md-steppers-container');
      el.style.transform = "translate3d(" + (-this.activeIndex * 100) + "%, 0 , 0)";
      el.style.transition = null;
      if (this.dragging) {
        this.dragging = false;
      }
    },
    goToStep(stepIndex) {
      this.activeIndex = stepIndex;
      this.active = this.element.list[this.activeIndex].uuid;
    },
    nextStep(currStep) {
      if (currStep < this.element.list.length - 1) {
        this.activeIndex = currStep + 1;
        this.active = this.element.list[this.activeIndex].uuid;
      }
    },
    prevStep(currStep) {
      if (currStep > 0) {
        this.activeIndex = currStep - 1;
        this.active = this.element.list[this.activeIndex].uuid;
      }
    },
    stepDone(currStep) {
      this.nextStep(currStep);
    },
    updateValidation(index, event) {
      this.validation[index] = event;
      this.validation = this.validation.slice(0);
      this.$emit("validation", this.valid);
    }
  },
  watch: {
    element() {
      this.active =
        this.element.list.length > 0 ? this.element.list[0].uuid : "";
    },
    active() {
      this.element.list.map((el, index) => {
        if (el.uuid == this.active) {
          this.activeIndex = index;
        }
      });
    }
  }
};
</script>
<style lang="scss">
.fb-step.fb-slider {
  .fb-actions {
    padding: 5px 0;
  }
  position: relative;
  .fb-actions {
    .md-icon-button {
      width: 32px;
      min-width: 32px;
      height: 32px;
      margin: 0 4px 0 4px;
    }
    button[disabled] {
      .step-icon.left-arrow {
        background-image: url('../../assets/left-arrow-dis.svg');
      }
      .step-icon.right-arrow {
        background-image: url('../../assets/right-arrow-dis.svg');
      }
    }
    .step-icon.left-arrow {
      background-image: url('../../assets/left-arrow.svg');
      &:hover {
        &::after {
          opacity: .1;
        }
      }
      &::after {
        content: '';
        display: block;
        position: absolute;
        top:0;
        left:0;
        right: 0;
        bottom: 0;
        background: black;
        opacity: 0;
        border-radius: 50%;
      }
    }
    .step-icon.right-arrow {
      background-image: url('../../assets/right-arrow.svg');
      &:hover {
        &::after {
          opacity: .1;
        }
      }
      &::after {
        content: '';
        display: block;
        position: absolute;
        top:0;
        left:0;
        right: 0;
        bottom: 0;
        background: black;
        opacity: 0;
        border-radius: 50%;
      }
    }
    .step-icon.active {
      background-image: url('../../assets/step_active.svg');
    }

    .step-icon {
      background-repeat: no-repeat;

      background-position: center center;
      background-image: url('../../assets/step_inactive.svg')
    }
  }

  .md-stepper,.md-stepper-content {
    min-height: 90px;
    @media all and (max-width: 500px) {
      min-height: 150px;
    }
  }
}

.md-steppers.md-alternative {
  background-color: transparent;
  margin-top: 60px;
  display: flex;
  flex-flow: column-reverse;
  .md-steppers-navigation {
    display: none;
    box-shadow: none;
  }
  border-radius: 20px;
}
</style>
